//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uuidv1 from 'uuid/v1';
import MemberEmail from '../../../secondary/account/profile/form/MemberEmail.vue';
import MemberPassword from '../../../secondary/account/profile/form/MemberPassword.vue';
import ErrorDisplay from '../../../common/ErrorDisplay.vue';
import Logo from '../../../common/svg/Logo';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Brooks1914RegistrationAccountModal',
  components: { MemberEmail, MemberPassword, ErrorDisplay, Logo },
  props: ['stepCompleted'],
  data() {
    return {
      open: false,
      loading: false,
      id: uuidv1(),
      email: '',
      password: '',
      error: null,
      errorDisplayMessage: null,
      coupon: null,
      teamId: null,
      pageState: '',
    };
  },
  created() {
    this.$container.eventBus.on('closeModal', (id) => {
      if (id === this.id) {
        this.close();
      }
    });
    this.coupon = 'b1914_2020';
    // Leaving this code commented so I can use it when we decide how are we getting the code for the surveys
    // this.coupon = this.$route.params.couponCode || null;
    // this.teamId = this.$route.params.teamId || null;
  },
  methods: {
    ...mapActions([
      'initialize', 'authenticate', 'register'
    ]),
    async login() {
      this.pageState = 'Signing In...';
      this.loading = true;
      this.error = null;
      try {
        await this.authenticate({ email: this.email, password: this.password });
        this.$emit('update:stepCompleted', 'existing');
        this.close();
      } catch (error) {
        this.errorDisplayMessage = 'Unable to log in';
        this.handle_error(error);
      } finally {
        this.loading = false;
      }
    },
    async createAccount() {
      this.pageState = 'Creating account...';
      this.loading = true;
      this.error = null;
      try {
        await this.register({ email: this.email, password: this.password, coupon: this.coupon });
        this.pageState = 'Loading Data...';

        await this.$store.dispatch('loadData');
        this.pageState = 'Success!';
        this.$container.analytics.trackRegistration(this.$store.state.user.memberId);

        this.$emit('update:stepCompleted', 'new');
        this.close();
      } catch (error) {
        this.errorDisplayMessage = 'Unable to create account';
        this.handle_error(error);
      } finally {
        this.loading = false;
      }
    },
    handle_error(error) {
      if (error.response && error.response.data) {
        this.error = error.response.data;
      } else {
        this.error = error;
      }
      this.loading = false;
    },
    launch() {
      this.open = true;
      this.$store.dispatch('pushModal', this.id);
    },
    close() {
      this.open = false;
      this.error = null;
      this.errorDisplayMessage = null;
      this.$store.dispatch('popModal');
    },
  },
  computed: {
    ...mapGetters([
      'user', 'isCoach',
    ]),
  },
};
